import { BaseEntity } from "../entities";
import { ApiClient } from "./client"

export class OpportunityProvider {
    static WonLevel = 13;
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/opportunity/${id}`) as Opportunity;
    }

    static async getAllByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/opportunity/by-organisation/all?organisationId=${organisationId}&page=${page}&size=${size}`) as Opportunity[];
    }

    static async getMyByOrganisation(organisationId: number, page = 0, size = 10) {
        return await this._apiClient.get(`/opportunity/by-organisation/my?organisationId=${organisationId}&page=${page}&size=${size}`) as Opportunity[];
    }

    static async save(opportunity: Opportunity) {
        return await this._apiClient.post('/opportunity', opportunity) as number;
    }
}

export interface Opportunity extends BaseEntity {
    OpportunityId: number
    OpportunityAssignedTo: number
    OpportunityAssignedTo2: number
    OpportunityLevelText: string
    OpportunityLevel: number
    OpportunityPipelineType: number
    OpportunityOrderDate: string
    OpportunityOrderValue: number
    OpportunityCurrencyName: string
    OpportunityDescription: string
    OpportunityNumber: string
    OpportunityOrganisationId: number
    OpportunityPersonId: number
    OpportunityPersonName: string
}
